var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
let TubeSpecificationSelection = class TubeSpecificationSelection extends Vue {
    constructor() {
        super(...arguments);
        this.index = 0;
    }
    onChange(event) {
        this.index = event.target.selectedIndex;
        return this.specifications[this.index].identifier;
    }
    initialize() {
        this.index = this.specifications.findIndex(m => m.identifier === this.originalTubeSpecificationId);
    }
    get specifications() {
        return this.shopConfig.tubeSpecifications.map(t => ({
            ...t,
            disabled: this.specificationIds.every(id => id !== t.identifier),
        }));
    }
    get specification() {
        return this.specifications[this.index];
    }
    mounted() {
        this.initialize();
    }
    originalTubeSpecificationIdChanged() {
        this.initialize();
    }
};
__decorate([
    Prop({ required: true })
], TubeSpecificationSelection.prototype, "specificationIds", void 0);
__decorate([
    Prop({ required: true })
], TubeSpecificationSelection.prototype, "originalTubeSpecificationId", void 0);
__decorate([
    Prop({ required: true })
], TubeSpecificationSelection.prototype, "shopConfig", void 0);
__decorate([
    Emit()
], TubeSpecificationSelection.prototype, "onChange", null);
__decorate([
    Inject()
], TubeSpecificationSelection.prototype, "i18n", void 0);
__decorate([
    Watch("originalTubeSpecificationId")
], TubeSpecificationSelection.prototype, "originalTubeSpecificationIdChanged", null);
TubeSpecificationSelection = __decorate([
    Component({
        components: {},
        name: "TubeSpecificationSelection",
    })
], TubeSpecificationSelection);
export default TubeSpecificationSelection;
